import { TextArea } from './text-area'

export { TextArea }
